import React from 'react';

const IconKey = props =>
  <svg viewBox="0 0 14 14" width="14px" height="14px" {...props}>
    <path d="M10.208,3.778 C9.693,3.265 9.693,2.434 10.208,1.922 L11.858,0.277 C10.58,-0.263 9.047,-0.015 8.005,1.023 C7.041,1.987 6.758,3.371 7.154,4.583 L0.509,11.207 C-0.042,11.757 -0.18,12.636 0.264,13.274 C0.848,14.113 2.013,14.189 2.702,13.502 L9.401,6.824 C10.618,7.218 12.005,6.937 12.972,5.974 C14.013,4.935 14.261,3.408 13.72,2.134 L12.07,3.779 C11.556,4.291 10.722,4.291 10.208,3.778 Z" />
  </svg>;

export default IconKey;
